import { Component } from '@angular/core';
import { JackpotHrService } from '../jackpot-hr.service';
import { CurrencyPipe } from '@angular/common';
import { ModalService } from '@features/modals/services/modal.service.js';
@Component({
  selector: 'app-jackpot-info-bar',
  templateUrl: './jackpot-info-bar.component.html',
  styleUrls: ['./jackpot-info-bar.component.scss'],
  standalone: true,
  imports: [CurrencyPipe],
})
export class JackpotInfoBarComponent {
  constructor(
    private modalService: ModalService,
    public jackpotService: JackpotHrService
  ) {}

  openJoinGame() {
    this.modalService.openModal('DepositJackpotModal');
  }
}
